<template>
  <div class="body-div">
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in tierTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedTierTab = tab.alias"
          :class="{ active: selectedTierTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in timeTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedTimeTab = tab.alias"
          :class="{ active: selectedTimeTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <div v-for="tab in tierTabs" :key="tab.id">
      <div
        class="top-div"
        v-if="selectedTimeTab === 'D' && selectedTierTab === tab.alias"
      >
        <div class="date-interval" v-if="!Array.isArray(transferRatio)">
          Daily: {{ transferRatio[1][0]["date_interval"] }}
        </div>
        <div class="transfer-type-tables" v-if="!Array.isArray(transferRatio)">
          <table
            v-for="type in transferRatio[tab.id][0]['transfer_types']"
            v-bind:key="type"
            v-if="type['users'].length > 0"
          >
            <tr>
              <th>score</th>
              <th>users</th>
              <th>{{ type.name }}</th>
            </tr>
            <tr
              v-if="salesPersonList.find(item => item.id === user.id)"
              v-for="user in type['users']"
              v-bind:key="user"
            >
              <td>{{ user.score }}</td>
              <td :class="{ 'notice-user': user.deposits_amount === 0 }">
                {{ salesPersonList.find(item => item.id === user.id).full_name
                }}<br />
                <span
                  class="report-rank"
                  v-for="rank in user.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
              <td>
                {{ user.transfers_amount }} | {{ user.deposits_amount }} |
                {{ user.ratio }}%
              </td>
            </tr>
          </table>
        </div>

        <loader class="loader" :size="'8px'" v-if="transferRatioBusy"></loader>
      </div>
      <div
        class="top-div"
        v-if="selectedTimeTab === 'W' && selectedTierTab === tab.alias"
      >
        <div class="date-interval" v-if="!Array.isArray(transferRatio)">
          Weekly: {{ transferRatio[1][1]["date_interval"] }}
        </div>
        <div class="transfer-type-tables" v-if="!Array.isArray(transferRatio)">
          <table
            v-for="type in transferRatio[tab.id][1]['transfer_types']"
            v-bind:key="type"
            v-if="type['users'].length > 0"
          >
            <tr>
              <th>score</th>
              <th>users</th>
              <th>{{ type.name }}</th>
            </tr>
            <tr
              v-if="salesPersonList.find(item => item.id === user.id)"
              v-for="user in type['users']"
              v-bind:key="user"
            >
              <td>{{ user.score }}</td>
              <td :class="{ 'notice-user': user.deposits_amount === 0 }">
                {{
                  salesPersonList.find(item => item.id === user.id).full_name
                }}
                <br />
                <span
                  class="report-rank"
                  v-for="rank in user.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
              <td>
                {{ user.transfers_amount }} | {{ user.deposits_amount }} |
                {{ user.ratio }}%
              </td>
            </tr>
          </table>
        </div>

        <loader class="loader" :size="'8px'" v-if="transferRatioBusy"></loader>
      </div>
      <div
        class="top-div"
        v-if="selectedTimeTab === 'M' && selectedTierTab === tab.alias"
      >
        <div class="date-interval" v-if="!Array.isArray(transferRatio)">
          Monthly: {{ transferRatio[1][2]["date_interval"] }}
        </div>
        <div class="transfer-type-tables" v-if="!Array.isArray(transferRatio)">
          <table
            v-for="type in transferRatio[tab.id][2]['transfer_types']"
            v-bind:key="type"
            v-if="type['users'].length > 0"
          >
            <tr>
              <th>score</th>
              <th>users</th>
              <th>{{ type.name }}</th>
            </tr>
            <tr
              v-if="salesPersonList.find(item => item.id === user.id)"
              v-for="user in type['users']"
              v-bind:key="user"
            >
              <td>{{ user.score }}</td>
              <td :class="{ 'notice-user': user.deposits_amount === 0 }">
                {{
                  salesPersonList.find(item => item.id === user.id).full_name
                }}
                <br />
                <span
                  class="report-rank"
                  v-for="rank in user.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
              <td>
                {{ user.transfers_amount }} | {{ user.deposits_amount }} |
                {{ user.ratio }}%
              </td>
            </tr>
          </table>
        </div>

        <loader class="loader" :size="'8px'" v-if="transferRatioBusy"></loader>
      </div>
      <div
        class="top-div"
        v-if="selectedTimeTab === 'Q' && selectedTierTab === tab.alias"
      >
        <div class="date-interval" v-if="!Array.isArray(transferRatio)">
          Quarterly: {{ transferRatio[1][3]["date_interval"] }}
        </div>
        <div class="transfer-type-tables" v-if="!Array.isArray(transferRatio)">
          <table
            v-for="type in transferRatio[tab.id][3]['transfer_types']"
            v-bind:key="type"
            v-if="type['users'].length > 0"
          >
            <tr>
              <th>score</th>
              <th>users</th>
              <th>{{ type.name }}</th>
            </tr>
            <tr
              v-if="salesPersonList.find(item => item.id === user.id)"
              v-for="user in type['users']"
              v-bind:key="user"
            >
              <td>{{ user.score }}</td>
              <td :class="{ 'notice-user': user.deposits_amount === 0 }">
                {{
                  salesPersonList.find(item => item.id === user.id).full_name
                }}
                <br />
                <span
                  class="report-rank"
                  v-for="rank in user.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
              <td>
                {{ user.transfers_amount }} | {{ user.deposits_amount }} |
                {{ user.ratio }}%
              </td>
            </tr>
          </table>
        </div>

        <loader class="loader" :size="'8px'" v-if="transferRatioBusy"></loader>
      </div>
      <div
        class="top-div"
        v-if="selectedTimeTab === 'H' && selectedTierTab === tab.alias"
      >
        <div class="date-interval" v-if="!Array.isArray(transferRatio)">
          Half Year: {{ transferRatio[1][4]["date_interval"] }}
        </div>
        <div class="transfer-type-tables" v-if="!Array.isArray(transferRatio)">
          <table
            v-for="type in transferRatio[tab.id][4]['transfer_types']"
            v-bind:key="type"
            v-if="type['users'].length > 0"
          >
            <tr>
              <th>score</th>
              <th>users</th>
              <th>{{ type.name }}</th>
            </tr>
            <tr
              v-if="salesPersonList.find(item => item.id === user.id)"
              v-for="user in type['users']"
              v-bind:key="user"
            >
              <td>{{ user.score }}</td>
              <td :class="{ 'notice-user': user.deposits_amount === 0 }">
                {{
                  salesPersonList.find(item => item.id === user.id).full_name
                }}
                <br />
                <span
                  class="report-rank"
                  v-for="rank in user.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
              <td>
                {{ user.transfers_amount }} | {{ user.deposits_amount }} |
                {{ user.ratio }}%
              </td>
            </tr>
          </table>
        </div>

        <loader class="loader" :size="'8px'" v-if="transferRatioBusy"></loader>
      </div>
      <div
        class="top-div"
        v-if="selectedTimeTab === 'Y' && selectedTierTab === tab.alias"
      >
        <div class="date-interval" v-if="!Array.isArray(transferRatio)">
          Yearly: {{ transferRatio[1][5]["date_interval"] }}
        </div>
        <div class="transfer-type-tables" v-if="!Array.isArray(transferRatio)">
          <table
            v-for="type in transferRatio[tab.id][5]['transfer_types']"
            v-bind:key="type"
            v-if="type['users'].length > 0"
          >
            <tr>
              <th>score</th>
              <th>users</th>
              <th>{{ type.name }}</th>
            </tr>
            <tr
              v-if="salesPersonList.find(item => item.id === user.id)"
              v-for="user in type['users']"
              v-bind:key="user"
            >
              <td>{{ user.score }}</td>
              <td :class="{ 'notice-user': user.deposits_amount === 0 }">
                {{
                  salesPersonList.find(item => item.id === user.id).full_name
                }}
                <br />
                <span
                  class="report-rank"
                  v-for="rank in user.rankings"
                  :key="rank"
                  v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                >
                  <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                    {{ rank["id"] }}:{{ rank["rank"] }}|
                  </span>
                </span>
              </td>
              <td>
                {{ user.transfers_amount }} | {{ user.deposits_amount }} |
                {{ user.ratio }}%
              </td>
            </tr>
          </table>
        </div>

        <loader class="loader" :size="'8px'" v-if="transferRatioBusy"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "TransferRatio.container",
  components: { Loader },
  data() {
    return {
      transferRatioBusy: false,
      transferRatio: [],
      timeTabs: [
        {
          id: 0,
          name: "Daily",
          alias: "D"
        },
        {
          id: 1,
          name: "Weekly",
          alias: "W"
        },
        {
          id: 2,
          name: "Monthly",
          alias: "M"
        },
        {
          id: 3,
          name: "Quarterly",
          alias: "Q"
        },
        {
          id: 4,
          name: "Half Yearly",
          alias: "H"
        },
        {
          id: 5,
          name: "Yearly",
          alias: "Y"
        }
      ],
      selectedTimeTab: "W",
      tierTabs: [
        {
          id: 1,
          name: "TIER 1",
          alias: "T1"
        },
        {
          id: 2,
          name: "TIER 2",
          alias: "T2"
        },
        {
          id: 3,
          name: "TIER 3",
          alias: "T3"
        },
        {
          id: 4,
          name: "TIER 4",
          alias: "T4"
        }
      ],
      selectedTierTab: "T1"
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {
    this.getLiveTransferRatioStats();
  },
  methods: {
    async getLiveTransferRatioStats() {
      this.transferRatio = [];
      if (
        !this.transferRatioBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.transferRatioBusy = true;
          const res = await apiClientCreator(
            `reports/campaigns/performance/suggested/transfers`
          ).get("");
          this.transferRatio = res.data;
          this.transferRatioBusy = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0 3.5em;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
.style-nav .router-link {
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.report-rank {
  font-size: 11px;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.endpoint-calls {
  display: flex;
  justify-content: center;
  padding: 2em 0;
}
.transfer-type-tables {
  display: flex;
  justify-content: space-around;
}
.loader {
  left: 0;
  right: 0;
}
.date-interval {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2em 0;
}
.notice-user {
  color: red;
}
</style>
